import questionCategory from './question-category'

export default {
  name: 'BaseInfoQuestionnaire',
  path: 'questionnaire',
  meta: {
    label: 'questionnaire',
    auth: 'questionnaire'
  },
  component: {
    name: 'Questionnaire',
    render(c) {
      return c('router-view')
    }
  },
  children: [questionCategory]
}
